<template>
  <div class="manual-entry-record">
    <Form inline class="i-form">
      <FormItem label="创建时间" :label-width="100">
        <DatePicker type="daterange" v-model="dateTime" :options="accountDateOptions" placeholder="请选择日期段、单天" class="date-time" style="width: 240px"></DatePicker>
      </FormItem>
      <FormItem label="结账月份" :label-width="100">
        <Select v-model="queryParams.settleDate" clearable style="width:150px">
          <Option v-for="(item, index) in checkoutMonth" :key="index" :value="item.settleDate">{{ item.settleDate }}</Option>
        </Select>
      </FormItem>
      <FormItem label="经营日期" :label-width="100">
        <DatePicker type="daterange" v-model="operatingDate" :options="accountDateOptions" placeholder="请选择日期段、单天" class="date-time" style="width: 240px"></DatePicker>
      </FormItem>
      <FormItem label="科目" :label-width="100">
        <Cascader :data="subjectData" change-on-select @on-change="handleSubject" style="width: 200px"></Cascader>
      </FormItem>
      <br>
      <FormItem label="审核状态" :label-width="100">
        <Select v-model="queryParams.checkStatus" clearable style="width:150px">
          <Option v-for="(item, index) in checkStatusArr" :key="index" :value="item.status">{{ item.value }}</Option>
        </Select>
      </FormItem>
      <FormItem label="业主" :label-width="100">
        <Input type="text" v-model.trim="queryParams.owner" placeholder="姓名/手机号"></Input>
      </FormItem>
      <FormItem label="门店" :label-width="76">
        <Select v-model="queryParams.chainId" clearable filterable placeholder="id/名称 输入下拉选择" style="width:250px">
          <Option v-for="(item, index) in allHotels" :key="index" :value="item.chainId">{{ `${item.chainId}_${item.chainName}` }}</Option>
        </Select>
      </FormItem>
      <FormItem label="房间" :label-width="120">
        <Input type="text" v-model.trim="queryParams.roomNo" placeholder="房号"></Input>
      </FormItem>
      <br>
      <FormItem label="订单号" :label-width="100">
        <Input type="text" v-model.trim="queryParams.orderNo"></Input>
      </FormItem>
      <FormItem label="工单号" :label-width="100">
        <Input type="text" v-model.trim="queryParams.cleanNo"></Input>
      </FormItem>
      <br>
      <FormItem>
        <Button type="primary" @click="handleBtn" style="margin-left: 32px; width: 100px;">查询</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="exportReport" :loading="exportLoading" style="margin-left: 32px; min-width: 125px;">导出筛选结果</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="addEditAccountBtn('add')" style="margin-left: 32px; width: 125px;">新增入账</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleBulkAccount" style="margin-left: 32px; width: 125px;">批量入账</Button>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="batchCheck" style="margin-left: 32px; width: 125px;">批量审核</Button>
      </FormItem>
      <FormItem>
        <Button @click="handleImportRecord" style="margin-left: 32px; width: 125px; background: none;">导入记录</Button>
      </FormItem>
    </Form>
    <!-- Table-->
    <Content>
      <Table ref="listModal" stripe :loading="consumloading" :columns="columns" :data="manualEntryData" @on-selection-change="handleSelChange" style="width:1615px;"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page 
          show-sizer 
          show-total
          placement="top" 
          :total="listCount" 
          :current="queryParams.page" 
          :page-size="queryParams.size"
          @on-page-size-change="changePageSize" 
          @on-change="changePage"
        >
        </Page>
      </div>
    </Content>
    <!-- 新增/更改入账弹窗 -->
    <Modal ref="addOrEditModal" :loading="true" v-model="newAccount.modal" :mask-closable="false" :title="newAccount.type === 'add' ? '新增入账' : '更改入账'" @on-cancel="resetNewResource" @on-ok="addOrEdit" width="600">
      <Form ref="accountInfo" :rules="accountValidate" :model="newAccount.formData">
        <FormItem prop="settleDate" label="结账月份" :label-width="150">
          <Select v-model="newAccount.formData.settleDate" clearable style="width:300px">
            <Option v-for="(item, index) in notCloseCheckoutMonth" :key="index" :value="item.settleDate">{{ item.settleDate }}</Option>
          </Select>
        </FormItem>
        <FormItem prop="accountDate" label="经营日期" :label-width="150">
          <DatePicker type="date" v-model="newAccount.formData.accountDate" :options="accountDateOptions" placeholder="请选择" class="date-time" style="width: 300px"></DatePicker>
        </FormItem>
        <FormItem prop="addEditSubject" label="科目" :label-width="150">
          <Cascader :data="addEditSubject" v-model="selSubjectData" :clearable="false" @on-change="handleSubject2" class="subject-item" style="width: 300px"></Cascader>
        </FormItem>
        <FormItem prop="xbedRoomId" label="Xbed房间ID" :label-width="150">
          <Input type="text" v-model.trim="newAccount.formData.xbedRoomId" style="width:300px"></Input>
          <p v-if="addEditTips.xbedRoomIdTips" class="inp_tips">房间id不存在，请检查</p>
        </FormItem>
        <FormItem prop="ownerMobile" label="业主手机号" :label-width="150">
          <Input type="text" v-model.trim="newAccount.formData.ownerMobile" style="width:300px" :maxlength="11"></Input>
          <p v-if="addEditTips.ownerMobileTips" class="inp_tips">业主手机号不存在，请检查</p>
        </FormItem>
        <FormItem prop="cleanNo" label="工单号" :label-width="150">
          <Input type="text" v-model.trim="newAccount.formData.cleanNo" style="width:300px"></Input>
          <p v-if="addEditTips.cleanNoTips" class="inp_tips">工单号不存在，请检查</p>
        </FormItem>
        <FormItem prop="orderNo" label="Xbed订单号" :label-width="150">
          <Input type="text" v-model.trim="newAccount.formData.orderNo" style="width:300px"></Input>
          <p v-if="addEditTips.orderNoTips" class="inp_tips">订单号不存在，请检查</p>
        </FormItem>
        <FormItem prop="realPrice" label="消费金额" :label-width="150">
          <Input type="text" v-model.trim="newAccount.formData.realPrice" placeholder="支出为负数，收入为正数" style="width:300px"></Input>
        </FormItem>
        <FormItem prop="settlementPrice" label="结算金额" :label-width="150">
          <Input type="text" v-model.trim="newAccount.formData.settlementPrice" placeholder="支出为负数，收入为正数" style="width:300px"></Input>
        </FormItem>
        <FormItem prop="remark" label="备注" :label-width="150">
          <Input v-model.trim="newAccount.formData.remark" type="textarea" style="width:300px" :autosize="{minRows: 3,maxRows: 6}" :maxlength="200" placeholder=""></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 审核弹窗 -->
    <Modal ref="checkResultModal" v-model="checkSource.modal" :loading="true" title="审核" width="400" :closable="false" ok-text="提交" @on-cancel="cancelCheck" @on-ok="commitCheck">
      <Form ref="checkResultForm" :rules="checkValidate" :model="checkSource.checkParam" :label-width="80">
        <FormItem prop="checkStatus" label="审核结果">
          <Select v-model="checkSource.checkParam.checkStatus" class="select-style">
            <Option value="1">已审核</Option>
            <Option value="3">取消</Option>
          </Select>
        </FormItem>
        <p v-if="showCheckTips" class="check-tips">*审核对象结账月份已关账，请先更改结账月份</p>
      </Form>
    </Modal>
    <!-- 更新历史弹窗 -->
    <Modal v-model="updateModal.display" title="更新历史" @on-cancel="closeUpdateList">
      <Table stripe :loading="updateloading" :columns="columns2" :data="updateModal.updateList"></Table>
      <div slot="footer"></div>
    </Modal>
    <!-- 批量入账弹窗 -->
    <Modal ref="downloadModal" v-model="downloadModal" title="批量入账" :loading="true" ok-text="开始导入" @on-cancel="handleClose" @on-ok="uploadFileBtn">
      <Form>
        <FormItem label="下载模板：" :label-width="100">
          <Button @click="downLoadFile">点击下载</Button>
        </FormItem>
        <FormItem label="文件：" :label-width="100">
          <Upload ref="uploadFileForm"
            :before-upload="handleBeforeUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
            :data="uploadData"
            :on-format-error="handleFormatError"
            :action="`${ accountUrl }manualRecord/importManual`">
            <Button type="primary">选择文件</Button>
            <Tag v-if="currentFile.name" closable @on-close="handleClose">{{currentFile.name}}</Tag>
          </Upload>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import API from "@/api";
import Config from "@/config";

export default {
	created() {
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.userid = Utils.findFromLocalStorage( "vue-userid" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.AuthorToken = Utils.findFromLocalStorage("Author-token");
    this.headerENV = Utils.aliHeaderEnv(this.env);
    this.accountUrl = Config[this.env].accountUrl;
	},

  data () {
    const validateSelect = {
      settleDate: (rule, value, callback) => {
        if (!this.newAccount.formData.settleDate) {
          callback(new Error('请选择结账月份'))
        } else {
          callback();
        }
      },
      accountDate: (rule, value, callback) => {
        if (!this.newAccount.formData.accountDate) {
          callback(new Error('请选择经营日期'));
        } else {
          callback();
        }
      },
      addEditSubject: (rule, value, callback) => {
        if (!this.newAccount.formData.subjectId) {
          callback(new Error('请选择科目'));
        } else {
          callback();
        }
      },
      xbedRoomId: (rule, value, callback) => {
        if (!this.newAccount.formData.xbedRoomId) {
          callback(new Error('请输入房间id'));
        } else {
          callback();
        }
      },
      realPrice: (rule, value, callback) => {
        if (!this.newAccount.formData.realPrice) {
          callback(new Error('请输入消费金额'));
        } else {
          callback();
        }
      },
      settlementPrice: (rule, value, callback) => {
        if (!this.newAccount.formData.settlementPrice) {
          callback(new Error('请输入结算金额'));
        } else {
          callback();
        }
      },
      remark: (rule, value, callback) => {
        if (!this.newAccount.formData.remark) {
          callback(new Error('备注不能为空'));
        } else {
          callback();
        }
      }
    }
    const checkSelect = {
      checkStatus: (rule, value, callback) => {
        if (!this.checkSource.checkParam.checkStatus) {
          callback(new Error('请选择审核状态'))
        } else {
          callback();
        }
      }
    }
    return {
      consumloading: false,
      updateloading: false,
      exportLoading: false, // 导出按钮loading
      downloadModal: false,
      showCheckTips: false, // 是否显示审核的提示语
      checkLoading: true,
      currentFile: {},
      format: ['xls','xlsx'],
      uploadData: {
        operator: '',
        operatorId: ''
      },
      dateTime: [ // 创建日期
        Moment().subtract(30, 'day').format('YYYY-MM-DD'),
        Moment().format('YYYY-MM-DD')
      ],
      checkStatusArr: [
        {
          value: '全部',
          status: '-1'
        },{
          value: '未审核',
          status: '0'
        },{
          value: '已审核',
          status: '1'
        },{
          value: '取消',
          status: '3'
        },
      ],
      operatingDate: [], // 经营日期
      selSubjectData: [], // 已选择的科目
      // 传给接口的查询字段
      queryParams: {
        page: 1, // 必选 页数
        size: 10, // 必选 行数
        createDateBegin: '', // 创建日期起
        createDateEnd: '', // 创建日期止
        accountDateBegin: '', // 经营日期起
        accountDateEnd: '', // 经营日期止
        settleDate: '', // 结账月份
        subjectId: '', // 一级科目Id
        sonSubjectId: '', // 二级科目Id
        checkStatus: '', // 审核状态
        owner: '', // 业主
        chain: '', // 门店
        roomNo: '', // 房号
        orderNo: '', // 订单号
        cleanNo: '' // 清洁单号
      },
      manualEntryData: [], // 表格列表数据
      listCount: 0, // 分页
      newAccount: {
        modal: false,
        type: 'add',
        formData: {
          settleDate: '', // 结账月份
          accountDate: '', // 经营日期
          subjectId: '', // 一级科目Id
          sonSubjectId: '', // 二级科目Id
          xbedRoomId: '', // xbed房间Id
          realPrice: '', // 消费金额
          settlementPrice: '', // 结算金额
          remark: '', // 备注
          operatorId: '', // 操作人Id
          operatorName: '', // 操作人
          ownerMobile: '', // 业主手机号
          cleanNo: '', // 工单号
          orderNo: '', // 订单号
          id: '' // 只有编辑的时候需要传
        }
      },
      checkSource: {
        modal: false,
        checkParam: {
          manualIds: '', // 手工导入记录Id,逗号分隔
          checkStatus: 0, // 审核状态 1--已审核 3--已取消
          operatorId: 0, // 操作人Id
          operatorName: '' // 操作人
        }
      },
      selManualIds: [], // 已经选择的审核项
      checkValidate: {
        checkStatus: [
          {required: true, validator: checkSelect.checkStatus, trigger: 'change' }
        ]
      },
      accountValidate: {
        settleDate: [
          {required: true, validator: validateSelect.settleDate, trigger: 'change' }
        ],
        accountDate: [
          {required: true, validator: validateSelect.accountDate, trigger: 'change' }
        ],
        addEditSubject: [
          {required: true, validator: validateSelect.addEditSubject, trigger: 'change' }
        ],
        xbedRoomId: [
          {required: true, validator: validateSelect.xbedRoomId, trigger: 'blur'},
        ],
        realPrice: [
          {required: true, validator: validateSelect.realPrice, trigger: 'blur'},
        ],
        settlementPrice: [
          {required: true, validator: validateSelect.settlementPrice, trigger: 'blur'},
        ],
        remark: [
          {required: true, validator: validateSelect.remark, trigger: 'blur'}
        ]
      },
      notCloseCheckoutMonth: [], // 未关账月份
      addEditTips: { // 新增/更改检查
        xbedRoomIdTips: false,
        ownerMobileTips: false,
        cleanNoTips: false,
        orderNoTips: false
      },
      addEditSubject: [
        {
          label: '房费',
          value: 41,
          dictValue: '1',
          children: [
            {
              label: '其它',
              value: 57,
              dictValue: '15'
            }
          ]
        },
        {
          label: '销售费用',
          value: 42,
          dictValue: '2',
          children: [
            {
              label: '渠道费用',
              value: 44,
              dictValue: '2'
            },
            {
              label: '发票税费',
              value: 53,
              dictValue: '10'
            },
            {
              label: '其它',
              value: 58,
              dictValue: '16'
            },
            {
              label: '交易手续费',
              value: 63,
              dictValue: '19'
            },
          ]
        },
        {
          label: '维护费用',
          value: 51,
          dictValue: '4',
          children: [
            {
              label: '清洁单费',
              value: 54,
              dictValue: '11'
            },
            {
              label: '洗涤费',
              value: 55,
              dictValue: '12'
            },
            {
              label: '易耗品费',
              value: 56,
              dictValue: '13'
            },
            {
              label: '其它',
              value: 60,
              dictValue: '18'
            },
          ]
        },
        {
          label: '管理费用',
          value: 43,
          dictValue: '3',
          children: [
            {
              label: '运营服务费',
              value: 61,
              dictValue: '14'
            },
            {
              label: '平台服务费',
              value: 45,
              dictValue: '3'
            },
            {
              label: '其它',
              value: 59,
              dictValue: '17'
            },
          ]
        }
      ],
      accountDateOptions: {
        disabledDate (current) {
          return current && current.valueOf() > Date.now()
        }
      },
      columns: [
        {
          type: 'selection',
          title: '全选本页',
          key: '',
          align: "center",
          width: 70
        },
        {
          title: '操作',
          key: '',
          align: "center",
          width: 150,
          render: ( h, params ) => {
            if (params.row.checkStatus === 0) {
              return h( "div", [
                h(
                  "Button",
                  {
                    props: {
                      size: "small",
                      type: "primary"
                    },
                    style: {
                      marginRight: '12px'
                    },
                    on: {
                      click: () => {
                        if ( !Utils.hasPermission( 'manualRecord_batchCheck' ) ) {
                          this.$Notice.error( {
                            title: "无权限操作"
                          } );
                          return
                        }
                        this.$refs.listModal.selectAll(false);
                        this.checkSource.modal = true
                        this.checkSource.checkParam.manualIds = params.row.id
                      }
                    }
                  },
                  "审核"
                ),
                h(
                  "Button",
                  {
                    props: {
                      size: "small",
                      type: "primary"
                    },
                    on: {
                      click: () => {
                        this.$refs.listModal.selectAll(false);
                        this.addEditAccountBtn('edit', params.row)
                      }
                    }
                  },
                  "更改"
                )
              ] );
            } else {
              return h("span", {}, "--")
            }
					}
        },
        {
          title: '审核状态',
          key: 'checkStatus',
          align: "center",
          width: 130,
          render:(h,params)=>{
            let checkName = '-'
            this.checkStatusArr.map(item => {
              if (params.row.checkStatus != -1 && params.row.checkStatus == item.status) {
                checkName = item.value
              }
            })
            return h('div',{}, checkName)
          }
        },
        {
          title: '结账月份',
          key: 'settleDate',
          align: "center",
          width: 130,
          render:(h,params)=>{
            let date = params.row.settleDate ? Moment(params.row.settleDate).format( 'YYYY-MM' ):'-'
            return h('div',{},date)
          }
        },
        {
          title: '一级科目',
          key: 'subjectName',
          align: "center",
          width: 130,
          render:(h,params)=>{
            return h('div',{}, params.row.subjectName ? params.row.subjectName : '-')
          }
        },
        {
          title: '二级科目',
          key: 'sonSubjectName',
          align: "center",
          width: 140,
          render:(h,params)=>{
            return h('div',{}, params.row.sonSubjectName ? params.row.sonSubjectName : '-')
          }
        },
        {
          title: '房间',
          key: '',
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("p", `${params.row.roomId ? params.row.roomId : '-'}_${params.row.roomNo ? params.row.roomNo : '-'}`)
          }
        },
        {
          title: '门店',
          key: '',
          align: "center",
          width: 230,
          render: (h, params) => {
            return h("p", `${params.row.chainId ? params.row.chainId : '-'}_${params.row.chainName ? params.row.chainName : '-'}`)
          }
        },
        {
          title: '业主',
          key: '',
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("p", `${params.row.ownerName ? params.row.ownerName : '-'}_${params.row.ownerMobile ? params.row.ownerMobile : '-'}`)
          }
        },
        {
          title: '经营日期',
          key: 'accountDate',
          align: "center",
          width: 140,
          render:(h,params)=>{
            let date = params.row.accountDate ? Moment(params.row.accountDate).format( 'YYYY-MM-DD' ):'-'
            return h('div',{},date)
          }
        },
        {
          title: '消费金额',
          key: 'realPrice',
          align: "center",
          width: 140,
          render: (h, params) => {
            let price = params.row.realPrice ? Number((params.row.realPrice/100).toFixed(2)) : '0'
            return h('div', {}, price)
          }
        },
        {
          title: '结算金额',
          key: 'settlementPrice',
          align: "center",
          width: 140,
          render: (h, params) => {
            let price = params.row.settlementPrice ? Number((params.row.settlementPrice/100).toFixed(2)) : '0'
            return h('div', {}, price)
          }
        },
        {
          title: '备注',
          key: 'remark',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('p', {
              style: {
                maxHeight: '40px',
                color: '#495060',
                display: '-webkit-box',
                overflow: 'hidden',
                margin: '8px 0 7px',
                webkitLineClamp: '2',
                webkitBoxOrient: 'vertical',
                wordBreak: 'break-all'
              },
              attrs: {
                title: params.row.remark
              }
            },
            params.row.remark ? params.row.remark : '-')
          }
        },
        {
          title: '工单号',
          key: 'cleanNo',
          align: "center",
          width: 188,
          render:(h,params)=>{
            return h('div',{}, params.row.cleanNo ? params.row.cleanNo : '-')
          }
        },
        {
          title: '订单号',
          key: 'orderNo',
          align: "center",
          width: 230,
          render:(h,params)=>{
            return h('div',{}, params.row.orderNo ? params.row.orderNo : '-')
          }
        },
        {
          title: '最近更新(点击查看历史)',
          key: '',
          align: "center",
          width: 200,
          render:(h,params)=>{
            return h('a',{
              on:{
                click:()=>{
                  this.OperationHistory(params.row.id)
                  this.updateModal.display = true;
                }
              }
            }, `${params.row.mtime ? params.row.mtime : '-'} | ${params.row.modifier ? params.row.modifier : '-'}`)
          }
        }
      ],
      columns2: [
        {
          title: '操作时间',
          key: 'operationDate',
          align: "center",
          width: 200,
          render:(h, params)=>{
            return h('div', {}, params.row.operationDate ? params.row.operationDate : '-')
          }
        },
        {
          title: '操作人',
          key: 'operator',
          align: "center",
          width: 100,
          render:(h, params)=>{
            return h('div', {}, params.row.operator ? params.row.operator : '-')
          }
        },
        {
          title: '更新内容',
          key: 'content',
          align: "center",
          width: 186,
          render:(h, params)=>{
            return h('div', {}, params.row.content ? params.row.content : '-')
          }
        },
      ],
      // 更新历史弹窗
      updateModal:{
        display:false,
        updateList: []
      },
    }
  },

  props: {
    // 科目下拉框数据
    subjectData: {
      type: Array,
      default() {
        return []
      }
    },

    // 所有门店下拉框数据
    allHotels: {
      type: Array,
      default() {
        return []
      }
    },

    // 所有结账月份
    checkoutMonth: {
      type: Array,
      default() {
        return []
      }
    }
  },

  mounted() {
    this.$Notice.config({
			top: 150
    });
    if ( !Utils.hasPermission( 'manualRecord_list' ) ) {
      this.$Notice.error( {
        title: "无权限操作"
      } );
      return
    }
    this.getManualRecord()
  },

  watch: {
    'newAccount.formData.xbedRoomId': function(val) {
      if (!val) {
        this.addEditTips.xbedRoomIdTips = false
      }
    }
  },

  methods: {
    // 结算报表列表 - 手工入账记录
    async getManualRecord() {
      this.consumloading = true
      let _queryParams = this.queryParams
      // 创建日期
      _queryParams.createDateBegin = this.dateTime[0] ? Moment(this.dateTime[0]).format('YYYY-MM-DD') : ''
      _queryParams.createDateEnd = this.dateTime[1] ? Moment(this.dateTime[1]).format('YYYY-MM-DD') : ''
        
      // 经营日期
      _queryParams.accountDateBegin = this.operatingDate[0] ? Moment(this.operatingDate[0]).format('YYYY-MM-DD') : ''
      _queryParams.accountDateEnd = this.operatingDate[1] ? Moment(this.operatingDate[1]).format('YYYY-MM-DD') : ''

      // 过滤空字段
      _queryParams = Object.keys(_queryParams).reduce(function(c, k) {
        if (_queryParams[k] && _queryParams[k] != -1 ) {
          c[k] = _queryParams[k]
        }
        return c
      }, {})
      
      const resp = (await API.omsAPI[this.env].clientServer.getManualRecord(_queryParams, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      this.consumloading = false
      if ( resp.retCode ) {
				this.$Notice.error( {
					title: resp.msg,
					desc: '获取手工入账记录数据异常'
				})
				return
			}
      resp.list.map(item => {
        if (item.checkStatus !== 0) {
          item['_disabled'] = true
        }
      })
      this.manualEntryData = resp.list || []
      this.listCount = resp.total
    },

    handleBtn() {
      this.queryParams.page = 1
      this.getManualRecord()
    },

    // 选择科目
    handleSubject(value, selectedData) {
      if (selectedData.length && selectedData[0].value) {
        this.queryParams.subjectId = selectedData[0].dictValue
        this.queryParams.sonSubjectId = selectedData.length === 2 ? selectedData[1].dictValue : 0
      } else {
        this.queryParams.subjectId = this.queryParams.sonSubjectId = 0
      }
    },

    // 弹窗里选择科目
    handleSubject2(value, selectedData) {
      if (selectedData.length && selectedData[0].value) {
        this.newAccount.formData.subjectId = selectedData[0].dictValue
        this.newAccount.formData.sonSubjectId = selectedData.length === 2 ? selectedData[1].dictValue : 0
      } else {
        this.newAccount.formData.subjectId = this.newAccount.formData.sonSubjectId = 0
      }
    },

    // 获取更新历史数据
    async OperationHistory(_id) {
      this.updateloading = true
      const resp = (await API.omsAPI[this.env].clientServer.getOperationHistory({ id: _id }, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
      this.updateloading = false
      if(resp.retCode){
        this.$Notice.error({
          title: resp.msg,
          desc: '获取数据失败'
        })
        return
      }
      this.updateModal.updateList = resp
    },

    // 关闭更新历史弹窗
    closeUpdateList() {
      setTimeout(() => {
        this.updateModal.updateList = []
      }, 500);
    },

    // 重置新增/更改弹窗字段
    resetNewResource() {
      let formData = this.newAccount.formData
      formData.settleDate = ''
      formData.accountDate = ''
      formData.subjectId = ''
      formData.sonSubjectId = ''
      formData.xbedRoomId = ''
      formData.realPrice = ''
      formData.settlementPrice = ''
      formData.remark = ''
      formData.ownerMobile = ''
      formData.cleanNo = ''
      formData.orderNo = ''
      formData.id = ''
      this.newAccount.modal = false;
      this.addEditTips.xbedRoomIdTips = false
      this.addEditTips.ownerMobileTips = false
      this.addEditTips.cleanNoTips = false
      this.addEditTips.orderNoTips = false
      this.selSubjectData = []
      this.$refs.accountInfo.resetFields();
    },

    // 新增/更改入账弹窗
    addEditAccountBtn(type, data) {
      if (type === 'add') {
        if ( !Utils.hasPermission( 'manualRecord_add' ) ) {
          this.$Notice.error( {
            title: "无权限操作"
          } );
          return
        }
      } else if (type === 'edit') {
        if ( !Utils.hasPermission( 'manualRecord_edit' ) ) {
          this.$Notice.error( {
            title: "无权限操作"
          } );
          return
        }
      }
      this.newAccount.type = type;
      this.newAccount.modal = true;
      this.$emit( 'getCloseMonth', true, (MonthResp) => {
				this.notCloseCheckoutMonth = MonthResp || []
			} )
      if (type === 'edit' && data) {
        let formData = this.newAccount.formData
        formData.settleDate = data.settleDate
        formData.accountDate = data.accountDate
        formData.subjectId = data.subjectId
        formData.sonSubjectId = data.sonSubjectId
        formData.xbedRoomId = data.roomId
        formData.realPrice = Number((data.realPrice / 100).toFixed(2))
        formData.settlementPrice = Number((data.settlementPrice / 100).toFixed(2))
        formData.remark = data.remark
        formData.ownerMobile = data.ownerMobile
        formData.cleanNo = data.cleanNo
        formData.orderNo = data.orderNo
        formData.id = data.id
        this.addEditSubject.map(sub => {
          if (sub.dictValue == data.subjectId) {
            this.selSubjectData.push(sub.value)
            if (data.sonSubjectId) {
              sub.children.map(sub2 => {
                if (sub2.dictValue == data.sonSubjectId) {
                  this.selSubjectData.push(sub2.value)
                }
                return
              })
            }
          }
        })
      }
    },

    // 请求新增/更改接口
    async addOrEdit() {
      this.$refs.addOrEditModal.buttonLoading = false;
      if(!this.validateResource('accountInfo')) {
        return
      }
      this.$refs.addOrEditModal.buttonLoading = true;
      let formData = this.newAccount.formData
      formData.accountDate = Moment(formData.accountDate).format( 'YYYY-MM-DD' )
      formData.operatorId = this.userid
      formData.operatorName = this.username
      // 过滤空字段
      formData = Object.keys(formData).reduce(function(c, k) {
        if (formData[k] ) {
          c[k] = formData[k]
        }
        return c
      }, {})
      try {
        let resp = ''
        if (this.newAccount.type === 'add') {
          resp = (await API.omsAPI[this.env].clientServer.addManualRecord(formData, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
        } else {
          resp = (await API.omsAPI[this.env].clientServer.editManualRecord(formData, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
        }
        this.$refs.addOrEditModal.buttonLoading = false;
        if(resp.retCode){
          let respMsg = JSON.parse(resp.msg)
          if (respMsg && respMsg.length) {
            this.addEditTips.xbedRoomIdTips = false
            this.addEditTips.ownerMobileTips = false
            this.addEditTips.cleanNoTips = false
            this.addEditTips.orderNoTips = false
            respMsg.map(item => {
              if (item.field === 'xbedRoomId') {
                this.addEditTips.xbedRoomIdTips = true
              } else if (item.field === 'ownerMobile') {
                this.addEditTips.ownerMobileTips = true
              } else if (item.field === 'cleanNo') {
                this.addEditTips.cleanNoTips = true
              } else if (item.field === 'orderNo') {
                this.addEditTips.orderNoTips = true
              }
            })
          }
          return
        } else {
          this.$Notice.success({
            title: '操作成功',
            desc: resp.msg
          })
        }
        this.resetNewResource()
        this.getManualRecord()
      } catch(e) {
        this.$refs.addOrEditModal.buttonLoading = false;
      }
    },

    // 检查必填项是否为空
    validateResource(name) {
      let _res;
      this.$refs[name].validate((valid) => {
        _res = valid ? true : false
      })
      return _res;
    },

    // 提交审核
    async commitCheck() {
      this.$refs.checkResultModal.buttonLoading = false;
      if(!this.validateResource('checkResultForm')) {
        return
      }
      this.$refs.checkResultModal.buttonLoading = true;
      let checkParam = this.checkSource.checkParam
      checkParam.operatorId = this.userid
      checkParam.operatorName = this.username
      try {
        let resp = (await API.omsAPI[this.env].clientServer.batchCheckRecord(checkParam, {'x-ca-stage':this.headerENV,'Authorization':this.AuthorToken})).data;
        this.$refs.checkResultModal.buttonLoading = false;
        if (resp.retCode === 41020000) {
          this.showCheckTips = true
          return
        }
        this.selManualIds = []
        this.cancelCheck()
        this.$Notice.success({
          title: '操作成功'
        })
        this.getManualRecord()
      } catch (e) {
        this.cancelCheck()
        this.$Notice.error({
          title: '提交审核失败，请稍后再试'
        })
      }
    },

    // 关闭审核弹窗
    cancelCheck() {
      this.showCheckTips = false
      this.checkSource.modal = false
      this.checkSource.checkParam.manualIds = ''
      this.checkSource.checkParam.checkStatus = 0
      this.$refs.checkResultForm.resetFields();
    },

    // 批量入账
    handleBulkAccount() {
      if ( !Utils.hasPermission( 'manualRecord_importManual' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      this.downloadModal = true
    },

    // 批量审核
    batchCheck() {
      if ( !Utils.hasPermission( 'manualRecord_batchCheck' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      if (!this.selManualIds.length) {
        this.$Notice.warning({
          title: '最少选择一项'
        })
        return
      }
      this.checkSource.modal = true
    },

    // 多选/全部操作
    handleSelChange(selected) {
      this.selManualIds = []
      if (selected && selected.length) {
        selected.map(item => {
          this.selManualIds.push(item.id)
        })
      }
      this.checkSource.checkParam.manualIds = this.selManualIds.join(',')
    },

    // 批量入账 - 导入操作
    downLoadFile() {
      let url = 'https://qiniu.xbed.com.cn/%E6%89%8B%E5%B7%A5%E5%AF%BC%E5%85%A5%E5%AF%B9%E8%B4%A6.xlsx';
      window.open(url)
    },
    handleClose() {
      this.currentFile = {}
      this.$refs.uploadFileForm.clearFiles();
    },
    handleBeforeUpload(file) {
      if(this.handleFormatError(file)){
        this.uploadData.operator = this.username
        this.uploadData.operatorId = this.userid
        this.currentFile = file;
      }
      return false;
    },
    uploadFileBtn() {
      if(!this.currentFile.name){
        this.$Notice.warning({
          title: '请选择excel文件'
        })
        this.$refs.downloadModal.buttonLoading = false;
        return
      }
      this.$refs.uploadFileForm.post(this.currentFile);
    },
    handleFormatError(file) {
      if (this.format.length) {
        const _file_format = file.name.split('.').pop().toLocaleLowerCase();
        const checked = this.format.some(item => item.toLocaleLowerCase() === _file_format);
        if (!checked) {
          this.$Notice.error({
            title: "不支持的文件格式",
            desc: '请选择.xls, .xlsx格式的文件'
          })
          return false;
        }
        return true
      }
    },
    handleSuccess(res) {
      this.downloadModal = false;
      if(res.retCode != 21020000) {
        this.errorUpdata(res)
        return
      }
      this.sureUpdata()
      this.getManualRecord();
      this.handleClose()
    },
    handleError(res) {
      this.downloadModal = false;
      this.errorUpdata(res)
      this.handleClose()
    },
    // 提交导入后成功的提示
    sureUpdata() {
      this.$Modal.confirm({
        content: '<p style="text-align:center; font-size: 14px;margin-bottom: 4px;">文件提交成功，系统正在处理，请勿重复提交！</p><p style="text-align:center; font-size: 14px;">稍等几分钟后可以查看本次导入记录</p>',
        okText: '导入记录',
        cancelText: '关闭',
        onOk: () => {
          if ( this.$router ) {
            window.open( '#/app/report/ManualRecord' )      // 跳转至导入记录（本地）
          } else {
            window.open( '#/Report/Report/manualRecord' )      // 跳转至导入记录（线上）
          }
        }
      });
    },
    // 提交导入后失败的提示
    errorUpdata(res) {
      this.$Modal.error({
        content: `<p style="text-align:center; font-size: 14px;margin-bottom: 4px;">文件提交失败，请检查文件重新提交！</p><p style="text-align:center; font-size: 14px;">失败原因：${res.msg}</p>`,
        okText: '知道了',
        onOk: () => {
          this.downloadModal = true;
        }
      });
    },

    // 跳转到导入记录页面
    handleImportRecord() {
      if ( !Utils.hasPermission( 'importRecord_list' ) ) {
        this.$Notice.error( {
          title: "无权限操作"
        } );
        return
      }
      if ( this.$router ) {
        window.open( '#/app/report/ManualRecord' )
      } else {
        window.open( '#/Report/Report/manualRecord' )
      }
    },

    // 分页
    changePageSize(pageSize) {
      this.queryParams.page = 1
      this.queryParams.size = pageSize
      this.getManualRecord()
    },
    changePage(pageIndex) {
      this.queryParams.page = pageIndex
      this.getManualRecord()
    },
    
    // 导出
    exportReport(){
      // if ( !Utils.hasPermission( 'manualRecord_exportManualRecord' ) ) {
      //   this.$Notice.error( {
      //     title: "无权限操作"
      //   } );
      //   return
      // }
      if (!this.manualEntryData.length) {
        this.$Notice.warning( {
          title: "无数据符合当前筛选条件，请调整"
        } );
        return
      }
      let _queryParams = this.queryParams
      // 创建日期
      _queryParams.createDateBegin = this.dateTime[0] ? Moment(this.dateTime[0]).format('YYYY-MM-DD') : ''
      _queryParams.createDateEnd = this.dateTime[1] ? Moment(this.dateTime[1]).format('YYYY-MM-DD') : ''
        
      // 经营日期
      _queryParams.accountDateBegin = this.operatingDate[0] ? Moment(this.operatingDate[0]).format('YYYY-MM-DD') : ''
      _queryParams.accountDateEnd = this.operatingDate[1] ? Moment(this.operatingDate[1]).format('YYYY-MM-DD') : ''
      
      // 过滤空字段并拼接参数
      const initParam = params => {
				let paramStr = '';
				Object.keys( params ).forEach( item => {
					if ( params[item] && params[item] != -1 ) {
						paramStr += item + '=' + params[item] + '&';
					}
				} )
				return paramStr.substring( 0, paramStr.lastIndexOf( '&' ) );
			}
      let paramsInfos = initParam(_queryParams);
			let url = `${ Config[this.env].accountUrl }manualRecord/exportManualRecord?${ paramsInfos }`;
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this, 'exportLoading' )
    }

  }

}
</script>

<style lang="scss" scoped>
.check-tips {
  font-size: 14px;
  color: red;
  margin: 0 0 10px 13px;
}
.inp_tips {
  position: absolute;
  line-height: 22px;
  color: red;
}
</style>





// WEBPACK FOOTER //
// src/pages/report/bill-statement/manual-entry-record.vue